import { render, staticRenderFns } from "./ColorSkuItem.vue?vue&type=template&id=2aca7e78&scoped=true&"
import script from "./ColorSkuItem.vue?vue&type=script&lang=js&"
export * from "./ColorSkuItem.vue?vue&type=script&lang=js&"
import style0 from "./ColorSkuItem.vue?vue&type=style&index=0&id=2aca7e78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aca7e78",
  null
  
)

export default component.exports